import setIn from 'Common/utils/setIn';
import findQuestionInQuestionnaireSections from 'ProjectManager/DataManagement/Questionnaire/helpers/findQuestionInQuestionnaireSections';
import withUpdatedCompletedStatusesInQuestionnaire from 'ProjectManager/DataManagement/Common/recoil/projectOrTemplate/modifiers/questionnaire/withUpdatedCompletedStatusesInQuestionnaire';

const withSingleChoiceAnswerForQuestion = (
    questionId,
    isCustomQuestion,
    selectedAnswerId,
) => prevProjectOrTemplate => {
    let questionnaireSections = [...prevProjectOrTemplate.questionnaireSections];

    const { question, questionPath } = findQuestionInQuestionnaireSections(
        questionnaireSections,
        questionId,
        isCustomQuestion,
    );

    if (!question) {
        return prevProjectOrTemplate;
    }

    const updatedQuestion = {
        ...question,
        singleOrMultipleAnswers: question.singleOrMultipleAnswers.map(
            answer => ({
                ...answer,
                isSelected: answer.id === selectedAnswerId,
            }),
        ),
    };

    questionnaireSections = setIn(
        questionnaireSections,
        questionPath,
        updatedQuestion,
    );

    return withUpdatedCompletedStatusesInQuestionnaire({
        ...prevProjectOrTemplate,
        questionnaireSections,
    });
};

export default withSingleChoiceAnswerForQuestion;
